module.exports = __webpack_public_path__ + "media/images/massage/main_image1@3x-a7aaaf168c9ab7bc63f6435d87cfaaed.jpg";